var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [_vm.$style.reports] },
    [
      _c("reports-title", {
        attrs: {
          title: "reports_access_title",
          "icon-color": "#00564C",
          "icon-name": "report",
          "has-tooltip": false,
        },
      }),
      _vm._v(" "),
      !_vm.pricingAccessToReports
        ? _c("pricing-stub", {
            attrs: { "is-owner": _vm.isOwner, "plan-title": _vm.planTitle },
          })
        : _c("div", { class: [_vm.$style.example_box] }, [
            _c("div", { class: _vm.$style.example_content_top }, [
              _c(
                "div",
                { class: _vm.$style.example_content_tabs },
                [
                  _c("vgp-tabs", {
                    attrs: {
                      tabs: _vm.sectionTabs,
                      active: _vm.activeTab,
                      "active-by": "id",
                      "blocked-inner-selection": true,
                      type: "button",
                    },
                    on: { onToggle: _vm.toggleTab },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { class: _vm.$style.feedback_button }, [
                _c(
                  "div",
                  {
                    class: _vm.$style.text_button,
                    on: { click: _vm.onClickFeedback },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.locale("header_contact_btn")) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "scrollContainer",
                class: [_vm.$style.example_content_charts, "gantt_scroll"],
              },
              [
                _c("div", { class: _vm.$style.example_content_container }, [
                  _c("div", {
                    style: { height: "36px" },
                    attrs: { id: "sec_0" },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "progressSec",
                      class: _vm.$style.example_content_item,
                      attrs: { id: "sec_1" },
                    },
                    [
                      _c("span", {
                        directives: [
                          {
                            name: "intersect",
                            rawName: "v-intersect",
                            value: _vm.handleIntersect,
                            expression: "handleIntersect",
                          },
                        ],
                        attrs: { id: "span_" + 1 },
                      }),
                      _vm._v(" "),
                      _c("progress-example", {
                        attrs: {
                          title: _vm.locale(
                            "report_tab_progress_and_performancel"
                          ),
                        },
                        on: { onCreateReport: _vm.createReport },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "budgetSec",
                      class: _vm.$style.example_content_item,
                      attrs: { id: "sec_2" },
                    },
                    [
                      _c("span", {
                        directives: [
                          {
                            name: "intersect",
                            rawName: "v-intersect",
                            value: _vm.handleIntersect,
                            expression: "handleIntersect",
                          },
                        ],
                        attrs: { id: "span_" + 2 },
                      }),
                      _vm._v(" "),
                      _c("budget-example", {
                        attrs: { title: _vm.locale("report_tab_budget") },
                        on: { onCreateReport: _vm.createReport },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: _vm.$style.example_content_item,
                      attrs: { id: "sec_3" },
                    },
                    [
                      _c("span", {
                        directives: [
                          {
                            name: "intersect",
                            rawName: "v-intersect",
                            value: _vm.handleIntersect,
                            expression: "handleIntersect",
                          },
                        ],
                        attrs: { id: "span_" + 3 },
                      }),
                      _vm._v(" "),
                      _c("time-example", {
                        attrs: { title: _vm.locale("report_tab_time") },
                        on: { onCreateReport: _vm.createReport },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
      _vm._v(" "),
      _vm.isShowForm
        ? _c("reports-form", {
            attrs: {
              title: _vm.reportTitle,
              "report-type": _vm.routerName,
              "show-form": _vm.isShowForm,
              "chart-type": _vm.chartType,
              "router-name": _vm.routerName,
            },
            on: { onToggle: _vm.createReport },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }